export default __webpack_public_path__ + "static/media/bill_logo.d91cdac9.png";